export default "__VITE_ASSET__DGd7LB7w__"